/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline. Keeping custom
* Javascript in this file will make it easier to update Pipeline.
*
* IMPORTANT:
* In order to use this file, open:
* Layout > theme.liquid
*
* Then make sure the custom.js script import line near the bottom
* of theme.liquid is uncommented / active.
*
*
* ------------------------------------------------------------
* NOA NOA CUSTOMIZATIONS
* ------------------------------------------------------------
*
* 1. PDP DEFAULT IMAGE
*
* Purpose:
* Shopify product media will be ordered as:
*
* Image 1 = Packshot
* Image 2 = Lifestyle / model image
*
* Collection / PLP:
* - Image 1 remains the primary product image.
* - Pipeline can continue to show Image 2 on hover.
*
* Product page / PDP:
* - When the PDP has finished loading, Image 2 is automatically
*   selected as the active image.
*
* Why:
* - Creates a cleaner and more consistent PLP using packshots.
* - Keeps the PDP more inspirational by opening on a lifestyle image.
*
* Important:
* - This does NOT change Shopify's actual product image order.
* - This does NOT change the Shopify featured image.
* - Image 1 remains available in the PDP gallery.
* - If a product has fewer than 2 images, nothing happens.
*
* Last updated: September 2026
* ------------------------------------------------------------
*/


(function() {

  // ------------------------------------------------------------
  // PIPELINE DEFAULT EXAMPLE EVENTS
  // ------------------------------------------------------------
  //
  // These event listeners are included by Pipeline as examples.
  // They listen for theme events that Pipeline fires and can be
  // used for future custom functionality.
  //
  // Keep scripts inside this IIFE to avoid leaking variables
  // into the global scope.
  // ------------------------------------------------------------


  document.addEventListener('theme:variant:change', function(event) {
    // Example:
    // Can be used for custom variant functionality,
    // pre-order features, swatches, etc.

    var variant = event.detail.variant;
    var container = event.target;

    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);

      console.log('Variant —————————— ↓');
      console.log(variant);

      // ... update some element on the page
    }
  });


  document.addEventListener('theme:cart:change', function(event) {
    // Example:
    // Fires whenever the cart changes.

    var cart = event.detail.cart;

    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);

      // ... update an app or custom shipping calculator
    }
  });


  // Fired when page loads to update header/cart values
  document.addEventListener('theme:cart:init', function(event) {
    console.log('theme:cart:init');
    console.log(event);
  });


  // Debounced scroll listeners.
  // Up and down only fire when scroll direction changes.
  document.addEventListener('theme:scroll', function(event) {
    console.log(event);
  });

  document.addEventListener('theme:scroll:up', function(event) {
    console.log(event);
  });

  document.addEventListener('theme:scroll:down', function(event) {
    console.log(event);
  });


  // Debounced resize listener
  document.addEventListener('theme:resize', function(event) {
    console.log(event);
  });


  // Locks and unlocks page scroll for modals and drawers.
  // These remain commented out because firing them directly
  // can lock the page scroll.
  //
  // document.dispatchEvent(
  //   new CustomEvent('theme:scroll:lock', {
  //     bubbles: true,
  //     detail: scrollableInnerElement
  //   })
  // );
  //
  // document.dispatchEvent(
  //   new CustomEvent('theme:scroll:unlock', {
  //     bubbles: true
  //   })
  // );


  

  // Keep custom scripts above this line and inside this IIFE.
})();